import { createActionGroup, props } from '@ngrx/store';

export const PaymentLinkActions = createActionGroup({
  source: 'Payment Links',
  events: {
    'Set Payment Link Custom Template Data': props<{
      templateId: string;
      templateName: string;
    }>(),
  },
});
